import styled, { css } from 'styled-components';

import { colors } from '@10d/tend-ui-tokens/samolet';

export const List = styled.ul.attrs({ role: 'combobox' })`
  padding: 0;
  margin: 0;
  max-height: 50vh;
  overflow: auto;
`;

export interface TimeListItem {
  hide?: boolean;
  disabled?: boolean;
  selected?: boolean;
}

export const Item = styled.li<TimeListItem>`
  ${({ hide, disabled }) =>
    hide
      ? disabled
        ? 'display: none;'
        : css`
            cursor: none;
            pointer-events: none;
            color: ${colors.gray400};
          `
      : ''}

  padding: 5px 10px;
  list-style-type: none;
  transition: all 0.4s ease-out;
  cursor: pointer;

  ${({ selected }) => selected && `background: ${colors.blue200}}`}

  &:hover {
    background: ${colors.blue200};
  }

  & .anticon-clock-circle {
    font-size: 16px;
  }
`;
